/**
 * Component that tracks pageviews automatically.
 */

import { usePageviewTracker } from '#~/analytics/pageview/index.js';

/**
 * PageviewTracker component.
 *
 * This component uses the usePageviewTracker hook to automatically
 * track pageviews when the route changes. It is deliberately childless so
 * React mounts its passive effect before effects in the routed app subtree;
 * a route's bootstrap/remount work must not outrun its pageview capture.
 * Per rule: reference-rules-in-comments (ai.knowledge/global).
 */
export const PageviewTracker = (): null => {
  usePageviewTracker();

  return null;
};
